import React from 'react';
import { useFormik } from 'formik';
import useTranslation from 'next-translate/useTranslation';

import { hooks as viewHooks } from '@/domains/view';

import Modal from '../Modal/Modal';
import { RadioWithTitle, TariffCard } from '../index';

import styles from './FindYourTariffModal.module.scss';

const FindYourTariffModal = ({
  active = false,
  setActive = () => null,
  data,
}) => {
  const [tariff, setTariff] = React.useState(null);
  const { lang } = useTranslation();
  const [tariffMutation] = viewHooks.useTariff();
  const initialRadioValues = data?.questions?.reduce((accum, item, index) => {
    return {
      ...accum,
      [index]: Array(item?.answers?.length || 2).fill(null),
    };
  }, {});

  const formik = useFormik({
    initialValues: {
      radio: initialRadioValues,
    },
  });
  React.useEffect(() => {
    const checkedValues = Object.values(formik?.values?.radio).filter(
      (item) => typeof item !== 'object',
    );

    if (data?.questions?.length === checkedValues?.length) {
      const answers = { answers: checkedValues };

      tariffMutation({ data: answers, lang })
        .unwrap()
        .then((res) => {
          setTariff(res);
        });
    }
  }, [data?.questions?.length, formik?.values?.radio, lang]);

  const renderQuestion = (item, index) => {
    const radioOnChange = (event, checkboxIndex) => {
      formik.setFieldValue(`radio.${index}`, item?.answers[checkboxIndex].id);
    };

    return (
      <div
        className={styles.question}
        key={index}
        itemScope
        itemType='https://schema.org/Question'
      >
        <span className={styles.title}>
          {index + 1}. {item.title}
        </span>
        <div className={styles.content}>
          {item?.answers?.map((checkbox, checkboxIndex) => (
            <RadioWithTitle
              checked={formik?.values?.radio[index][checkboxIndex]}
              onChange={(event) => radioOnChange(event, checkboxIndex)}
              name={`${index}_question`}
              key={`${checkboxIndex}_question`}
              className={styles.input}
              classNameTitle={styles.inputTitle}
            >
              {checkbox.text}
            </RadioWithTitle>
          ))}
        </div>
      </div>
    );
  };

  const resetForm = () => {
    formik.resetForm();
    setTariff(null);
  };

  const closeModal = () => {
    resetForm();
    setActive(false);
  };

  return (
    <Modal
      active={active}
      setActive={setActive}
      itemScope
      itemType='https://schema.org/Offer'
    >
      <div className={styles.container}>
        {tariff ? (
          <div>
            <span
              dangerouslySetInnerHTML={{
                __html: `${tariff?.name} ${data?.result_title}`,
              }}
              className={styles.title}
            ></span>
            <div className={styles.tariff}>
              <TariffCard
                className={styles.tariffCard}
                item={tariff}
                onClick={closeModal}
              />
            </div>
            <div className={styles.findAnother}>
              <button
                aria-label={data?.pop_up_bottom_text}
                className={styles.button}
                onClick={resetForm}
              >
                {data?.pop_up_bottom_text}
              </button>
            </div>
          </div>
        ) : (
          <div>
            <span
              dangerouslySetInnerHTML={{
                __html: data?.title,
              }}
              className={styles.title}
            ></span>
            <div className={styles.slider}>
              {data?.questions?.map(renderQuestion)}
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default FindYourTariffModal;
